import React from 'react';
import Modal from '@components/widgets/Modal';
import Button from '@components/forms/Button';
import { LenderStatusEnum } from '@types';

// Define BrokerUser interface for row typing
interface BrokerUser {
  userId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  lenderReference?: string;
  lastLogin?: string | null;
  status: LenderStatusEnum;
  lenderOrganisationId: string;
  isAdmin?: boolean;
  roles?: string[];
}

interface AcceptRequestModalProps {
  open: boolean;
  row: BrokerUser | null;
  onClose: () => void;
  onConfirm: (row?: BrokerUser | null) => void;
  showSuccessMessage?: boolean;
}

const AcceptRequestModal: React.FC<AcceptRequestModalProps> = ({
  open,
  row,
  onClose,
  onConfirm,
  showSuccessMessage
}) => {
  return (
    <Modal open={open} onClose={onClose} size="md" title="Accept Broker Access Request">
      <div className="px-4 py-6">
        {showSuccessMessage ? (
          <div className="flex flex-col items-center gap-4">
            <div className="text-success-600 text-2xl">Request Accepted!</div>
            <div className="text-grey-700">
              The broker’s access request has been accepted.
            </div>
            <Button color="primary" onClick={onClose}>
              Close
            </Button>
          </div>
        ) : (
          <>
            <div className="text-grey-700 mb-6">
              {row ? (
                <>
                  Are you sure you want to accept broker
                  <span className="font-bold">{' '}{row.email}</span>
                  {row.firstName || row.lastName ? (
                    <>
                      {' '}({row.firstName}{row.firstName && row.lastName ? ' ' : ''}{row.lastName})
                    </>
                  ) : null}
                  's access request?
                </>
              ) : (
                "Are you sure you want to accept this broker's access request?"
              )}
            </div>
            <div className="flex justify-end gap-3">
              <Button 
              className="border bg-white border-grey-300 text-grey-700 normal-case font-semibold rounded-lg text-sm py-2 px-4 w-full focus:ring-2 focus:ring-offset-1 focus:ring-primary-focus"
              variant="outlined" onClick={onClose}>
                Cancel
              </Button>
              <Button
                className="font-semibold bg-primary normal-case rounded-lg text-sm text-white w-full py-2 px-4 whitespace-nowrap hover:bg-primary-dark focus:ring-2 focus:ring-offset-1 focus:ring-primary-focus" // Adjusted styling
                onClick={() => onConfirm(row)}>
                Accept
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default AcceptRequestModal;

